import * as DialogPrimitive from "@radix-ui/react-dialog";

export const DialogClose = DialogPrimitive.Close;
